import React, { useEffect, useState } from 'react';
const LAUNCH_END_TIMESTAMP = new Date('2026-07-24T01:00:00-03:00').getTime();
const TOTAL_SLOTS = 300;
const TAKEN_SLOTS = 260;
const REMAINING_SLOTS = TOTAL_SLOTS - TAKEN_SLOTS;
const TAKEN_PERCENTAGE = TAKEN_SLOTS / TOTAL_SLOTS * 100;
type TimeRemaining = {
  hours: string;
  minutes: string;
  seconds: string;
  isExpired: boolean;
};
function getTimeRemaining(): TimeRemaining {
  const remainingMilliseconds = Math.max(0, LAUNCH_END_TIMESTAMP - Date.now());
  const totalSeconds = Math.floor(remainingMilliseconds / 1000);
  if (totalSeconds <= 0) {
    return {
      hours: '00',
      minutes: '00',
      seconds: '00',
      isExpired: true
    };
  }
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  return {
    hours: String(hours).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0'),
    isExpired: false
  };
}
export function LaunchCountdown() {
  const [time, setTime] = useState<TimeRemaining>(getTimeRemaining);
  useEffect(() => {
    if (time.isExpired) return undefined;
    const interval = window.setInterval(() => {
      const nextTime = getTimeRemaining();
      setTime(nextTime);
      if (nextTime.isExpired) {
        window.clearInterval(interval);
      }
    }, 1000);
    return () => window.clearInterval(interval);
  }, [time.isExpired]);
  return <section aria-label="Precio de lanzamiento" className="w-full bg-ink-950 px-5 py-12 sm:py-16" data-id="element-128" data-mp="8uv5ehaxipgc">
      <div className="launch-countdown-card mx-auto w-full max-w-xl rounded-[22px] border border-[rgba(78,240,122,0.25)] p-6 sm:p-[30px]" data-id="element-129" data-mp="dswnaywmciq8">
        <div className="inline-flex items-center gap-2 rounded-full border border-[rgba(255,82,82,0.35)] bg-[rgba(255,82,82,0.12)] px-3 py-1.5 text-xs font-bold uppercase tracking-wide text-[#ff5252]" data-id="element-130" data-mp="mv5wnlg5i621">
          <span className="launch-countdown-alert-dot h-2 w-2 rounded-full bg-[#ff5252]" aria-hidden="true" data-id="element-131" data-mp="2omiyg1mtnxtv" />
          Precio de lanzamiento — quedan {REMAINING_SLOTS} cupos
        </div>

        <h2 className="mt-5 text-xl font-extrabold tracking-tight text-white sm:text-[23px]" data-id="element-132" data-mp="3rz9jhoyjp01u">
          Este precio cierra en:
        </h2>
        <p className="mt-2 max-w-md text-sm leading-relaxed text-[#9aa39a]" data-id="element-133" data-mp="4sz2pu3bf4ph">
          Después de este momento, <strong className="font-semibold text-white" data-id="element-134" data-mp="3vxyw3fbredkf">Capital Consciente</strong> pasa a valer{' '}
          <strong className="font-semibold text-white" data-id="element-135" data-mp="epv5rkag2ymn">$69.000</strong>. No vuelve a bajar.
        </p>

        {time.isExpired ? <div className="mt-8 border-y border-[rgba(78,240,122,0.18)] py-8 text-center" data-id="element-136" data-mp="9rjxhdzssw6j">
            <p className="text-base font-semibold text-white" data-id="element-137" data-mp="nif74si4fhb6">El precio de lanzamiento cerró.</p>
          </div> : <>
            <div className="mt-8 flex items-center justify-center gap-1.5 sm:gap-3" aria-label={`Quedan ${time.hours} horas, ${time.minutes} minutos y ${time.seconds} segundos`} data-id="element-138" data-mp="xh4q6olr77t0">
              <TimeUnit value={time.hours} label="HS" data-id="element-139" data-mp="1c3tq2rjx3mzx" />
              <Separator data-id="element-140" data-mp="1c28t6va4rryw" />
              <TimeUnit value={time.minutes} label="MIN" data-id="element-141" data-mp="1h2wm5mhx6ivr" />
              <Separator data-id="element-142" data-mp="1h2en6i3vhqk5" />
              <TimeUnit value={time.seconds} label="SEG" isTicking data-id="element-143" data-mp="125xexzqzcs1t" />
            </div>

            <p className="mt-7 text-center text-sm font-bold text-white sm:text-base" data-id="element-144" data-mp="1289sm0ppgg92">
              Después sube <span className="text-[#ffb43d]" data-id="element-145" data-mp="176tj8ef8ug7r">$41.000 ARS</span> — no vuelve a este precio
            </p>
          </>}

        {!time.isExpired && <div className="mt-8 border-t border-[rgba(78,240,122,0.16)] pt-6" data-id="element-146" data-mp="y53oaym5kz58">
            <div className="flex items-center justify-between gap-4 text-xs sm:text-sm" data-id="element-147" data-mp="jg7cqrkw13zv">
              <p className="flex items-center gap-2 font-bold text-[#4ef07a]" data-id="element-148" data-mp="odz9bywh9eae">
                <span className="relative flex h-2 w-2" aria-hidden="true" data-id="element-149" data-mp="aezo7186bhiz">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#4ef07a] opacity-60" data-id="element-150" data-mp="agu7kb3sr1ky" />
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-[#4ef07a]" data-id="element-151" data-mp="7cv7r12bfrga" />
                </span>
                Cupos al precio de lanzamiento
              </p>
              <p className="whitespace-nowrap text-base font-extrabold text-[#ffb43d]" data-id="element-152" data-mp="2ge7x9lr7ond">
                Quedan {REMAINING_SLOTS}
              </p>
            </div>

            <div className="mt-3 h-2.5 overflow-hidden rounded-full bg-[#14201a]" role="progressbar" aria-label="Cupos al precio de lanzamiento tomados" aria-valuemin={0} aria-valuemax={TOTAL_SLOTS} aria-valuenow={TAKEN_SLOTS} data-id="element-153" data-mp="3osuucgq0n0mh">
              <div className="launch-countdown-progress relative h-full overflow-hidden rounded-full bg-gradient-to-r from-[#2f9e4f] to-[#4ef07a]" style={{
            width: `${TAKEN_PERCENTAGE}%`
          }} data-id="element-154" data-mp="3avxxnyn7uoxo">
                <span className="launch-countdown-shimmer absolute inset-y-0 w-1/3" aria-hidden="true" data-id="element-155" data-mp="142vtssbavttw" />
              </div>
            </div>
            <p className="mt-3 text-xs text-[#9aa39a]" data-id="element-156" data-mp="1cjwd5ky58lbc">{TAKEN_SLOTS} de {TOTAL_SLOTS} cupos tomados</p>
          </div>}
      </div>
    </section>;
}
type TimeUnitProps = {
  value: string;
  label: string;
  isTicking?: boolean;
};
function TimeUnit({
  value,
  label,
  isTicking = false
}: TimeUnitProps) {
  return <div className="min-w-[70px] rounded-2xl border border-[rgba(78,240,122,0.26)] bg-[linear-gradient(180deg,rgba(78,240,122,0.10),rgba(78,240,122,0.01))] px-2 py-4 text-center sm:min-w-[92px] sm:px-3" data-id="element-157" data-mp="1qdx8s5tsts7h">
      <div className={`font-mono text-[32px] font-black leading-none tabular-nums text-[#4ef07a] [text-shadow:0_0_22px_rgba(78,240,122,0.6)] sm:text-[46px] ${isTicking ? 'launch-countdown-tick' : ''}`} data-id="element-158" data-mp="xoykeqz31ttq">
        {value}
      </div>
      <p className="mt-3 text-[10px] font-bold tracking-[0.14em] text-[#9aa39a]" data-id="element-159" data-mp="2e0vjemv8m5xh">{label}</p>
    </div>;
}
function Separator() {
  return <span aria-hidden="true" className="font-mono text-2xl font-bold text-[rgba(78,240,122,0.55)] sm:text-3xl" data-id="element-160" data-mp="1tccf5t9d9vpv">
      :
    </span>;
}